import { Link } from 'react-router-dom';
import InviteButton from './InviteButton';
import { useFirebase } from './FirebaseContextProvider';
import { UsersRoles } from '../utils/enums';
import { useTournamentParts, useEntities } from '../utils/hooks';
import Avatar from './Avatar';
import Spinner from './Spinner';
import './FieldManagersList.scss';

export default function FieldManagersList({ tournamentId }) {
  const { tournamentsById } = useFirebase();

  const areManagersReady = useTournamentParts(tournamentId, ['managers']);

  const tournament = tournamentsById.get(tournamentId) || {};

  // The subcollection holds uids; the documents behind them are read by id —
  // there is no organization-wide users list to look them up in any more
  const managerIds = (tournament.managers || []).map((manager) => manager.id);
  const { entities, isResolved } = useEntities('users', managerIds);

  const managers = !(areManagersReady && isResolved)
    ? []
    : entities.filter(Boolean).sort((a, b) =>
        (a.name || '').localeCompare(b.name || '', 'en', {
          sensitivity: 'base',
        }),
      );

  return (
    <div className='field-managers-list'>
      <div className='sticky-top'>
        <div className='controls'>
          <div className='filters' />
          <InviteButton
            invited='field managers'
            tokenCreatePayload={{
              role: UsersRoles.FIELDMANAGER,
              tournament: tournamentId,
            }}
          >
            Invite managers
          </InviteButton>
        </div>

        <ul className='tab-header'>
        <li className='col-1' />
        <li className='col-2'>Name</li>
        <li className='col-3'>E-mail</li>
        <li className='col-4'>Phone</li>
        <li className='col-34'>E-mail, Phone</li>
        <li className='col-234'>Name, E-mail, Phone</li>
      </ul>
      </div>

      <div className='tab-body'>
        {/* An empty roster is a claim, not a blank: it invites the admin to
            send invitations to managers who are already assigned */}
        {!(areManagersReady && isResolved) && <Spinner show inline />}
        {managers.map((manager) => {
          const { id, name, email, phone } = manager;

          return (
            <Link key={id} to={`/field-managers/${id}`} className='manager'>
              <Avatar user={manager} size={64} className='col-1' />
              <p className='col-2 upper font-medium'>{name}</p>
              <p className='col-3'>{email}</p>
              <p className='col-4'>{phone}</p>
              <div className='col-34'>
                <p>{email}</p>
                <p>{phone}</p>
              </div>
              <div className='col-234'>
                <div className='img-name-wrap'>
                  <Avatar user={manager} size={32} />
                  <p className='upper font-medium'>{name}</p>
                </div>
                <p>{email}</p>
                <p>{phone}</p>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
